import { useQuery } from '@apollo/client'

import { GetProductModalDocument } from '@/graphql/purchase-plus/generated/getProductModal.generated'
import { TagTypeEnum } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { checkNetworkStatus } from '@/modules/shared/utils/checkNetworkStatus'

interface UseGetProductModalProps {
  productId: number
  skip?: boolean
  supplierId?: number
}

export const useGetProductModal = ({ productId, skip, supplierId }: UseGetProductModalProps) => {
  const { data, networkStatus, error, refetch } = useQuery(GetProductModalDocument, {
    variables: {
      productId,
      supplierId: supplierId || 0,
      tagFilters: {
        tagTypeEq: TagTypeEnum.Product,
      },
    },
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache', // TODO: schema migration: maybe remove? type mismatches were causing outer queries with this products data to refetch
    skip,
  })

  const product = data?.product

  const loadingStates = checkNetworkStatus(networkStatus)

  return {
    error,
    product,
    loadingStates,
    refetch,
  }
}
